/* eslint-disable capitalized-comments */
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { PbDevice } from './types.js';
import type { DeviceSetting, State } from '#~/device/settings/index.js';

/**
 * Convert a protobuf device to a JS device.
 *
 * @param pbDevice - Protobuf device.
 * @returns JS device.
 * @internal
 */
export const pbToJsDeviceSettings = (pbDevice: PbDevice): T_Maybe<State> => {
  const valueMap: Record<number, DeviceSetting> = {};
  const valueTimestampMap: Record<number, number> = {};

  Object.entries(pbDevice.pbStatus?.deviceSettings?.settings ?? {}).forEach(([key, value]) => {
    if (Number(key) === -1) {
      return;
    }

    const { direct, select, toggle, lastModified, inquiryError } = value ?? {};

    valueMap[Number(key)] = {
      direct,
      select,
      toggle,
      error: inquiryError?.message
    };

    const timestamp = lastModified ?? -1;

    valueTimestampMap[Number(key)] = timestamp;
  });

  Object.entries(pbDevice.pbControl?.deviceSettings ?? {}).forEach(([key, value]) => {
    if (Number(key) === -1) {
      return;
    }

    const { direct, select, toggle, action, lastModified } = value ?? {};

    const timestamp = lastModified ?? -1;

    if (timestamp > (valueTimestampMap[Number(key)] ?? -1) && action === undefined) {
      valueMap[Number(key)] = {
        direct,
        select,
        toggle
      };
    }
  });

  return valueMap;
};
